// src/ably.js
import Ably from 'ably';

// Initialize Ably client
// You can use an API key from environment variable or token authentication
// For now, we'll use a placeholder - you should set VUE_APP_ABLY_API_KEY in your .env file
const ablyApiKey = process.env.VUE_APP_ABLY_API_KEY || '';

let ablyClient = null;

export const getAblyClient = () => {
  if (!ablyClient && ablyApiKey) {
    ablyClient = new Ably.Realtime({
      key: ablyApiKey,
      // Optional: configure other options
      // clientId: 'client-id',
      // echoMessages: false,
    });
  }
  return ablyClient;
};

export const disconnectAbly = () => {
  if (ablyClient) {
    ablyClient.close();
    ablyClient = null;
  }
};
